/* ================================================================
   GRAFF PINK — drop theme.js
   Plomberie Shopify (panier AJAX, curseur, transitions, reveal) repris
   du thème graff pink + logique de drop éphémère reprise de Motherlode
   (flip-clock countdown, password gate, fenêtre 48h, lecteur audio).
   ================================================================ */
(() => {
  const T = window.theme || {};
  const SETT = T.settings || {};
  const ROUTES = T.routes || {};
  const DROP = T.drop || {};
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad2 = n => String(n).padStart(2, '0');

  /* ============================================================
     CURSOR
  ============================================================ */
  if (SETT.enable_cursor && matchMedia('(hover:hover)').matches) {
    document.documentElement.classList.add('cursor-on');
    const c = $('.cursor'), dot = $('.cursor__dot'), ring = $('.cursor__ring');
    if (c) {
      let x = innerWidth/2, y = innerHeight/2, rx = x, ry = y;
      addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
      const loop = () => {
        rx += (x-rx)*0.22; ry += (y-ry)*0.22;
        if (dot)  dot.style.transform  = `translate(${x}px,${y}px) translate(-50%,-50%)`;
        if (ring) ring.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`;
        requestAnimationFrame(loop);
      };
      loop();
      const hoverSel = 'a,button,input,[data-open-cart],[data-go-product],.shop-card,.product-cta';
      document.addEventListener('mouseover', e => { if (e.target.closest(hoverSel)) c.classList.add('is-hover'); });
      document.addEventListener('mouseout',  e => { if (e.target.closest(hoverSel)) c.classList.remove('is-hover'); });
    }
  }

  /* ============================================================
     REVEAL ON SCROLL
  ============================================================ */
  if (SETT.enable_reveal && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(el => io.observe(el));
  } else { $$('[data-reveal]').forEach(el => el.classList.add('is-in')); }
  setTimeout(() => $$('[data-reveal]:not(.is-in)').forEach(el => el.classList.add('is-in')), 2500);

  /* ============================================================
     PAGE TRANSITIONS
  ============================================================ */
  const pt = $('.page-transition');
  if (SETT.enable_transitions && pt) {
    // arrivée : l'aplat rose couvre (is-cover, depuis le markup) → balaie vers le haut pour révéler la page
    const reveal = () => {
      pt.classList.remove('is-parked', 'is-cover');
      requestAnimationFrame(() => {
        pt.classList.add('is-reveal');
        setTimeout(() => { pt.classList.remove('is-reveal'); pt.classList.add('is-parked'); }, 680);
      });
    };
    reveal();
    // retour via bouton précédent (bfcache) : recouvre puis re-révèle
    addEventListener('pageshow', e => { if (e.persisted) { pt.classList.remove('is-reveal'); pt.classList.add('is-cover'); reveal(); } });
    // départ : l'aplat rose remonte pour couvrir, puis on navigue
    document.addEventListener('click', e => {
      const a = e.target.closest('a[data-transition-link]');
      if (!a) return;
      const url = a.getAttribute('href');
      if (!url || url.startsWith('#') || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
      try { if (new URL(url, location.href).origin !== location.origin) return; } catch(_) { return; }
      e.preventDefault();
      pt.classList.remove('is-parked', 'is-reveal');
      pt.classList.add('is-cover');
      setTimeout(() => { location.href = url; }, 560);
    });
  }

  /* ============================================================
     FLIP CLOCK — build + animate (repris de motherlode)
  ============================================================ */
  const FC_LABELS = { d: 'Jours', h: 'Heures', m: 'Min', s: 'Sec' };
  function buildFlipClock(host) {
    const units = (host.dataset.units || 'h,m,s').split(',');
    const withLabels = host.classList.contains('fc-with-labels');
    host.innerHTML = units.map((u, i) => {
      const sep = (i < units.length - 1) ? '<div class="fc-sep">:</div>' : '';
      const digits = [0,1].map(() => `
        <div class="fc-digit">
          <div class="fc-card fc-active"><div class="fc-half fc-up"><span class="fc-inn">0</span></div><div class="fc-half fc-down"><span class="fc-inn">0</span></div></div>
          <div class="fc-card fc-before" hidden><div class="fc-half fc-up"><span class="fc-inn">0</span></div><div class="fc-half fc-down"><span class="fc-inn">0</span></div></div>
        </div>`).join('');
      return `<div class="fc-group" data-unit="${u}"><div class="fc-digits">${digits}</div>${withLabels ? `<div class="fc-label">${FC_LABELS[u]||''}</div>` : ''}</div>${sep}`;
    }).join('');
  }
  function setFlipDigit(el, ch) {
    const active = el.querySelector('.fc-active'), before = el.querySelector('.fc-before');
    const old = active.querySelector('.fc-inn').textContent;
    if (old === ch) return;
    active.querySelectorAll('.fc-inn').forEach(s => s.textContent = ch);
    before.querySelectorAll('.fc-inn').forEach(s => s.textContent = old);
    before.hidden = false; el.classList.add('is-flipping');
    setTimeout(() => { el.classList.remove('is-flipping'); before.hidden = true; }, 600);
  }
  function updateFlipClock(host, vals) {
    Object.entries(vals).forEach(([unit, val]) => {
      const g = host.querySelector(`.fc-group[data-unit="${unit}"]`);
      if (!g) return;
      const str = String(val).padStart(2, '0');
      g.querySelectorAll('.fc-digit').forEach((d, i) => setFlipDigit(d, str[i] || '0'));
    });
  }
  $$('.flipclock[data-units]').forEach(buildFlipClock);

  /* ============================================================
     DROP WINDOW — countdown (verrouillage produits) + overlay « drop terminé »
     (le mot de passe / gate a été retiré du site)
  ============================================================ */
  const OPEN_TS  = DROP.open  ? new Date(DROP.open).getTime()  : null;
  const CLOSE_TS = DROP.close ? new Date(DROP.close).getTime() : null;

  const isOpen   = () => OPEN_TS == null || Date.now() >= OPEN_TS;
  const isClosed = () => CLOSE_TS != null && Date.now() >= CLOSE_TS;

  const ended = $('.drop-ended');

  function syncState() {
    document.documentElement.classList.toggle('is-locked-countdown', !isOpen() && !isClosed());
    document.body.classList.toggle('is-locked', !!(ended && ended.classList.contains('is-active')));
  }

  function tickWindow() {
    const now = Date.now();
    if (CLOSE_TS != null) {
      const r = Math.max(0, CLOSE_TS - now);
      $$('.flipclock-window').forEach(c => updateFlipClock(c, { h: Math.floor(r/3600000), m: Math.floor((r%3600000)/60000), s: Math.floor((r%60000)/1000) }));
    }
    if (OPEN_TS != null) {
      const r = Math.max(0, OPEN_TS - now);
      $$('.flipclock-open').forEach(c => updateFlipClock(c, { d: Math.floor(r/86400000), h: Math.floor((r%86400000)/3600000), m: Math.floor((r%3600000)/60000), s: Math.floor((r%60000)/1000) }));
    }
    if (ended) {
      const was = ended.classList.contains('is-active');
      ended.classList.toggle('is-active', isClosed());
      if (!was && isClosed()) document.querySelectorAll('.product-cta, .cart-checkout').forEach(b => b.setAttribute('disabled',''));
    }
    syncState();
  }
  if (OPEN_TS != null || CLOSE_TS != null) { tickWindow(); setInterval(tickWindow, 1000); }
  else syncState();

  /* ============================================================
     TOAST
  ============================================================ */
  const toast = $('#toast'); let toastT;
  const showToast = msg => { if (!toast) return; toast.textContent = msg; toast.classList.add('is-show'); clearTimeout(toastT); toastT = setTimeout(() => toast.classList.remove('is-show'), 2200); };

  /* ============================================================
     SHOPIFY CART (endpoints /cart/*.js) + drawer
  ============================================================ */
  const drawer = $('[data-cart-drawer]');
  const itemsEl = $('[data-cart-items]');
  const emptyEl = $('[data-cart-empty]');
  const footEl  = $('[data-cart-foot]');
  const subEl   = $('[data-cart-subtotal]');
  const countEls = $$('[data-cart-count]');
  const escapeHtml = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => {
    const v = cents/100;
    try { return new Intl.NumberFormat('fr-FR', { style:'currency', currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR' }).format(v); }
    catch(_) { return v.toFixed(2).replace('.', ',') + ' €'; }
  };
  let lenis = null; // hook si Lenis ajouté plus tard
  const openCart  = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('is-locked'); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); if (!(ended && ended.classList.contains('is-active'))) document.body.classList.remove('is-locked'); };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  function renderCart(cart) {
    countEls.forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = '';
      itemsEl.style.display = 'none';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    itemsEl.style.display = '';
    if (footEl) footEl.style.display = '';
    itemsEl.innerHTML = cart.items.map(it => {
      const variant = (it.variant_title && it.variant_title !== 'Default Title') ? escapeHtml(it.variant_title).toLowerCase() : '';
      const img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_200x$1') : '';
      return `<li class="cart-item" data-line="${it.key}">
        <a href="${it.url}" data-transition-link>${img ? `<img class="cart-item__img" src="${img}" alt="${escapeHtml(it.product_title)}">` : `<span class="thumb-fallback">${escapeHtml(it.product_title).slice(0,3).toUpperCase()}</span>`}</a>
        <div class="cart-item__info">
          <a href="${it.url}" data-transition-link><span class="cart-item__title">${escapeHtml(it.product_title).toLowerCase()}</span></a>
          ${variant ? `<span class="cart-item__size">${variant}</span>` : ''}
          <div class="cart-line qty" style="border:0;padding:0">
            <button type="button" data-qty-dec aria-label="Diminuer">−</button>
            <span class="v">${it.quantity}</span>
            <button type="button" data-qty-inc aria-label="Augmenter">+</button>
            <button type="button" class="cart-item__rm" data-remove style="margin-left:10px">retirer</button>
          </div>
        </div>
        <div class="pp">${it.final_line_price === 0 ? 'offert' : money(it.final_line_price)}</div>
      </li>`;
    }).join('');
    if (subEl) subEl.textContent = money(cart.total_price);
  }
  async function getCart() {
    const r = await fetch(ROUTES.cart_url + '.js', { headers:{Accept:'application/json'} }); return r.json();
  }
  async function refreshCart() {
    if (!ROUTES.cart_url) return;
    try { renderCart(await getCart()); } catch(_){}
  }

  /* ---- Place offerte avec un bundle (auto-gift) ----
     Quand un produit "bundle" (tee + cd) est au panier, on synchronise
     automatiquement la quantité de la "place" gratuite (1 place / bundle).
     Réglages : settings.auto_place_enabled · place_variant_id · bundle_keyword. */
  const GIFT = T.gift || {};
  const isBundleItem = it => {
    const k = (GIFT.bundleKeyword || 'bundle').toLowerCase();
    return (it.handle && it.handle.indexOf(k) > -1) || ((it.product_type || '').toLowerCase().indexOf(k) > -1);
  };
  async function cartAdd(id, qty, props) {
    const item = { id: parseInt(id, 10), quantity: qty };
    if (props) item.properties = props;
    const r = await fetch(ROUTES.cart_add_url + '.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body: JSON.stringify({ items:[item] }) });
    return r.ok;
  }
  async function cartChangeRaw(key, qty) {
    await fetch(ROUTES.cart_change_url + '.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body: JSON.stringify({ id:key, quantity:qty }) });
  }
  async function reconcileGift() {
    if (!GIFT.enabled || !GIFT.variantId) return;
    try {
      const cart = await getCart();
      const units = cart.items.filter(isBundleItem).reduce((s, i) => s + i.quantity, 0);
      const line = cart.items.find(i => String(i.variant_id) === String(GIFT.variantId));
      const have = line ? line.quantity : 0;
      if (units === have) return;
      if (units === 0 && line) await cartChangeRaw(line.key, 0);
      else if (line) await cartChangeRaw(line.key, units);
      else if (units > 0) await cartAdd(GIFT.variantId, units, { '_place': 'offerte avec le bundle' });
    } catch(_) {}
  }

  async function addToCart(id, qty = 1) {
    if (isClosed()) { showToast('drop fermé'); return; }
    if (!ROUTES.cart_add_url) { showToast('boutique non connectée'); return; }
    try {
      if (!(await cartAdd(id, qty))) throw 0;
      await reconcileGift();
      await refreshCart(); openCart(); showToast('✓ ajouté au panier');
    } catch(_) { showToast('impossible d\'ajouter'); }
  }
  async function changeLine(key, qty) {
    if (!ROUTES.cart_change_url) return;
    try { await cartChangeRaw(key, qty); await reconcileGift(); await refreshCart(); } catch(_){}
  }
  if (drawer) {
    drawer.addEventListener('click', e => {
      const item = e.target.closest('[data-line]'); if (!item) return;
      const key = item.dataset.line;
      const cur = parseInt(item.querySelector('.v').textContent, 10) || 0;
      if (e.target.closest('[data-remove]'))  return changeLine(key, 0);
      if (e.target.closest('[data-qty-inc]')) return changeLine(key, cur + 1);
      if (e.target.closest('[data-qty-dec]')) return changeLine(key, Math.max(0, cur - 1));
    });
  }
  refreshCart();

  /* ============================================================
     PRODUCT DETAIL — galerie · tailles · variantes · add
  ============================================================ */
  // thumbnails / cycle main media
  function setMain(host, idx) {
    const medias = $$('[data-media]', host);
    if (!medias.length) return;
    idx = ((idx % medias.length) + medias.length) % medias.length;
    medias.forEach((m, i) => { m.hidden = i !== idx; if (m.tagName === 'VIDEO') { if (i===idx) m.play().catch(()=>{}); else m.pause(); } });
    $$('[data-thumb]', host).forEach((b, i) => b.setAttribute('aria-current', i === idx ? 'true' : 'false'));
    host.dataset.idx = idx;
  }
  $$('[data-gallery]').forEach(g => {
    setMain(g, 0);
    g.addEventListener('click', e => {
      const th = e.target.closest('[data-thumb]');
      if (th) { setMain(g, parseInt(th.dataset.thumb, 10)); return; }
      if (e.target.closest('[data-media].has-multi') || e.target.closest('.shop-visual.has-multi')) {
        setMain(g, (parseInt(g.dataset.idx || 0, 10)) + 1);
      }
    });
  });

  // product form: option → variant resolve + add
  const form = $('[data-product-form]');
  if (form) {
    const variantsEl = form.querySelector('[data-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const variantInput = form.querySelector('[data-variant-id]');
    const addBtn = form.querySelector('[data-add-btn]');
    const priceLbl = form.querySelector('[data-add-price]');
    const syncVariant = () => {
      const selected = $$('[data-option-input]:checked', form).map(i => i.value);
      const match = variants.find(v => v.options.every((o, idx) => o === selected[idx])) || variants[0];
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (addBtn) addBtn.disabled = !match.available;
      const lbl = addBtn && addBtn.querySelector('[data-add-label]');
      if (lbl) lbl.textContent = match.available ? (T.strings.add_to_cart || 'ajouter au panier') : (T.strings.sold_out || 'épuisé');
      if (priceLbl && match.price != null) priceLbl.textContent = match.price === 0 ? 'gratuit' : money(match.price);
    };
    $$('[data-option-input]', form).forEach(i => i.addEventListener('change', () => {
      // aria-pressed sync for visual buttons
      const name = i.name;
      $$(`[data-option-input][name="${CSS.escape(name)}"]`, form).forEach(o => {
        const lab = o.closest('label'); if (lab) lab.setAttribute('aria-pressed', o.checked ? 'true' : 'false');
      });
      syncVariant();
    }));
    syncVariant();
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const id = variantInput ? variantInput.value : null;
      if (!id) return;
      addBtn.disabled = true; await addToCart(id, 1); addBtn.disabled = false; syncVariant();
    });
  }

  // standalone add buttons (placeholder / preview cards)
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add-variant]');
    if (!b) return; e.preventDefault(); addToCart(b.dataset.addVariant, 1);
  });

  /* ============================================================
     NEWSLETTER (capture locale → brancher Klaviyo/Shopify ensuite)
  ============================================================ */
  const nForm = $('#newsletterForm'), nStatus = $('#newsletterStatus');
  if (nForm) nForm.addEventListener('submit', e => {
    e.preventDefault();
    const input = nForm.querySelector('input[type="email"]'); const email = (input.value||'').trim();
    if (!email || !email.includes('@')) { nStatus.textContent = 'email invalide.'; nStatus.classList.remove('is-ok'); return; }
    try { const l = JSON.parse(localStorage.getItem('gp-newsletter')||'[]'); if (!l.includes(email)) l.push(email); localStorage.setItem('gp-newsletter', JSON.stringify(l)); } catch(_){}
    nStatus.textContent = 'inscrit · merci.'; nStatus.classList.add('is-ok'); input.value = '';
  });

  /* ============================================================
     LEGAL TABS — navigation entre pages légales (si présentes)
  ============================================================ */
  document.addEventListener('click', e => {
    const t = e.target.closest('button[data-legal-tab]');
    if (!t) return;
    const slug = t.dataset.legalTab;
    const base = (t.closest('[data-legal-base]') || {}).dataset?.legalBase || '/pages/';
    location.href = base + slug;
  });

  /* ============================================================
     LECTEUR AUDIO — SHARP SHOOTER · son dès l'ouverture + repris à chaque page
  ============================================================ */
  (function audio() {
    const el = $('#aplayer'); if (!el) return;
    const src = el.dataset.src; if (!src) return;
    const POS = 'gp-audio-pos', MUTE = 'gp-audio-muted';
    const a = new Audio(src); a.loop = true; a.preload = 'auto';
    const isMuted = () => { try { return sessionStorage.getItem(MUTE) === '1'; } catch(_) { return false; } };
    try { const p = parseFloat(sessionStorage.getItem(POS)); if (p > 0) a.currentTime = p; } catch(_) {}
    a.addEventListener('play',  () => el.classList.add('is-playing'));
    a.addEventListener('pause', () => el.classList.remove('is-playing'));
    setInterval(() => { try { if (!a.paused) sessionStorage.setItem(POS, a.currentTime); } catch(_) {} }, 1000);
    // démarrage dès l'ouverture (autoplay tenté, sinon au 1er geste — navigateurs bloquent le son sans interaction)
    if (!isMuted()) a.play().catch(() => {});
    const onGesture = () => { if (!isMuted() && a.paused) a.play().catch(() => {}); };
    ['click','touchstart','keydown'].forEach(ev => document.addEventListener(ev, onGesture, { capture: true }));
    el.addEventListener('click', e => {
      e.stopPropagation();
      if (a.paused) { try { sessionStorage.setItem(MUTE, '0'); } catch(_) {} a.play().catch(() => {}); }
      else { try { sessionStorage.setItem(MUTE, '1'); } catch(_) {} a.pause(); }
    });
  })();

  /* ============================================================
     COOKIE BANNER (RGPD)
  ============================================================ */
  const cookie = $('#cookie');
  if (cookie) {
    let choice = null; try { choice = localStorage.getItem('gp_cookie_choice'); } catch(_){}
    if (!choice) setTimeout(() => { cookie.classList.add('is-show'); cookie.setAttribute('aria-hidden','false'); }, 900);
    cookie.addEventListener('click', e => {
      const b = e.target.closest('[data-cookie]'); if (!b) return;
      try { localStorage.setItem('gp_cookie_choice', b.dataset.cookie); } catch(_){}
      cookie.classList.remove('is-show'); cookie.setAttribute('aria-hidden','true');
      if (window.Shopify && Shopify.customerPrivacy) { try { Shopify.customerPrivacy.setTrackingConsent(b.dataset.cookie === 'accept', () => {}); } catch(_){} }
    });
  }
})();
